import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { pushDetailImpression } from '../../utils/data-layer';
import { extractListingDataLayerData } from '../../utils/transformers';

const EcommerceProductView = ({ contacts, currentLocation, yachtData }) => {
  useEffect(() => {
    pushDetailImpression(extractListingDataLayerData(yachtData, contacts));
  }, []);

  return null;
};

EcommerceProductView.propTypes = {
  contacts: PropTypes.array.isRequired,
  currentLocation: PropTypes.string.isRequired,
  yachtData: PropTypes.object.isRequired
};

export default EcommerceProductView;
